import API, { API_URL } from "api/API";

export default async function fetchImages() {
  const {data} = await API.get(API_URL.DISPLAY.FETCH_IMAGES);

  return data;
}